import {StockItem} from '../../../shared-utilities/models-old/datastructures';

export interface IAutoOrderOrderStockItem extends StockItem, Object {
  flagged?: boolean;
  poOnHold?: boolean;
}
